import { render, staticRenderFns } from "./SiteTypeSearchResult.vue?vue&type=template&id=1122ca03&scoped=true"
import script from "./SiteTypeSearchResult.vue?vue&type=script&lang=js"
export * from "./SiteTypeSearchResult.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1122ca03",
  null
  
)

export default component.exports